import React, { useRef, useState, useEffect } from 'react';
import styles from '../deupraiabarretos/deupraiabarretos.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import catalogoPdf from './src/catalogo-deupraiabarretos.pdf';
import cardapioPdf from './src/cardapio-deupraiabarretos.pdf';
import CardapioIcon from '../../icons/cardapioIcon.tsx';

const Deupraiabarretos: React.FC = () => {

    return (
        <div className={styles.deupraiabarretos}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "250px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>DEU PRAIA</h1>
                    <p className="mb-0">ESPORTE E LAZER PARA TODAS AS IDADES!</p>
                    <p>LOCAÇÃO DE QUADRAS, AULAS E DAY USE.</p>
                    <div className={styles.links}>
                        <Link
                            href="https://wa.me/5517997761900?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Agendar (Dalquir)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://wa.me/5517981236847?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Falar (Adriano)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://wa.me/5517991529730?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Falar (Léo)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://wa.me/5517991753054?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Treinos Volêi (Cleyton)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://wa.me/5517991818572?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Treinos Futevôlei (Lucas Castor)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        {/* <Link
                            href="https://wa.me/5517988159160?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Treinos Futevôlei (Natã)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        /> */}
                        <Link
                            href="https://wa.me/5517991979039?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Treinos Futevôlei (Ana Prado)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://wa.me/5517988312214?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                            title="Treinos Futevôlei (Cauã)"
                            icon={<WhatsappIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://www.instagram.com/deupraiabarretos?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon height="32" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href={catalogoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon color="#703628" height="35" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                        <Link
                            href="https://maps.app.goo.gl/W8cBigKJGQU42s8F8"
                            title="Localização"
                            icon={<MapsIcon height="40" color="#703628" />}
                            backgroundColor="#2ec9ce"
                            backgroundColorHover="#20abb0"
                            colorText="#703628"
                            maxWSpan={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Deupraiabarretos;
